class User {
  constructor(buildData) {
    this.firstName = buildData.firstName;
    this.lastName = buildData.lastName;
    this.email = buildData.email;
    this.userId = buildData.userId;
    this.role = buildData.role;
    this.grade = buildData.grade;
    this.guest = buildData.guest;
  }

  isStudent() {
    return this.role === 0;
  }

  isTeacher() {
    return this.role === 1;
  }

  isParent() {
    return this.role === 2;
  }
}

class UserView {
  constructor(user) {
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.email;
    this.userId = user.userId;
  }
}

class UserBuilder {
  setFirstName(val) {
    this.firstName = val;
    return this;
  }

  setLastName(val) {
    this.lastName = val;
    return this;
  }

  setEmail(val) {
    this.email = val;
    return this;
  }

  setUserId(val) {
    this.userId = val;
    return this;
  }

  setRole(val) {
    this.role = val;
    return this;
  }

  seRole(val) {
    this.role = val;
    return this;
  }
  setGrade(val) {
    this.grade = val;
    return this;
  }

  setGuest(val) {
    this.guest = val;
    return this;
  }

  build() {
    return new User(this);
  }
}

function getUserBuilder() {
  return new UserBuilder();
}

function createUserView(user) {
  return new UserView(user);
}

export default {
  getUserBuilder,
  createUserView,
};
